import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("btn_home");

  return (
    <nav className="shadow-md fixed w-screen md:w-[60%] z-50 md:rounded-full md:mt-2 justify-center">
      <div className="container mx-auto px-4 py-1 flex justify-between items-center">
        <a href="/" className="text-2xl font-bold text-gray-800">
            <img className='logo-navbar' src='/Logo_name.svg' alt='Cudaki'/>
        </a>

        <div className="hidden md:flex space-x-6">
          <Link to="home" smooth={true} duration={500} offset={-50} id="btn_home" href="#" className={`menu-item ${activeItem === "btn_home" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_home")}>Strona główna</Link>
          <Link to="about" smooth={true} duration={500} offset={-50} id="btn_about" href="#" className={`menu-item ${activeItem === "btn_about" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_about")}>O nas</Link>
          <Link to="team" smooth={true} duration={500} offset={-50} id="btn_team" href="#" className={`menu-item ${activeItem === "btn_team" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_team")}>Zespół</Link>
          <Link to="services" smooth={true} duration={500} offset={-50} id="btn_services" href="#" className={`menu-item ${activeItem === "btn_services" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_services")}>Usługi</Link>
          <Link to="gallery" smooth={true} duration={500} offset={-75} id="btn_gallery" href="#" className={`menu-item ${activeItem === "btn_gallery" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_gallery")}>Galeria</Link>
          <Link to="contact" smooth={true} duration={500} offset={-50} id="btn_contact" href="#" className={`menu-item ${activeItem === "btn_contact" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_contact")}>Kontakt</Link>
        </div>

        <div className="flex gap-2 md:min-w-[200px] md:justify-center">
          <a href="https://www.facebook.com/profile.php?id=61575618311436" target="_blank" className="hover:scale-105">
            <img src="/icons/fb.svg" className="w-7 h-7" />
            </a>
          <a href="https://www.instagram.com/gabinetcudaki/" target="_blank" className="hover:scale-105">
            <img src="/icons/ig.svg" className="w-7 h-7" />
          </a>
        </div>

        <button className="md:hidden" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <img src="/icons/close.svg" className="w-7 h-7" /> : <img src="/icons/menu.svg" className="w-7 h-7" />}
        </button>
      </div>

      {isOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -10 }} 
          animate={{ opacity: 1, y: 0 }} 
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
          className="flex flex-wrap gap-x-6 justify-center items-center"
        >
          <div className="h-[30px]">
            <Link to="home" smooth={true} duration={500} offset={-150} id="btn_sm_home" href="#" className={`menu-item ${activeItem === "btn_sm_home" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_sm_home")}>Strona główna</Link>
          </div>
          <div className="h-[30px]">
            <Link to="about" smooth={true} duration={500} offset={-150} id="btn_sm_about" href="#" className={`menu-item ${activeItem === "btn_sm_about" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_sm_about")}>O nas</Link>
          </div>
          <div className="h-[30px]">
            <Link to="team" smooth={true} duration={500} offset={-150} id="btn_sm_team" href="#" className={`menu-item ${activeItem === "btn_sm_team" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_sm_team")}>Zespół</Link>
          </div>
          <div className="h-[30px]">
            <Link to="services" smooth={true} duration={500} offset={-150} id="btn_sm_services" href="#" className={`menu-item ${activeItem === "btn_sm_services" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_sm_services")}>Usługi</Link>
          </div>
          <div className="h-[30px]">
            <Link to="gallery" smooth={true} duration={500} offset={-175} id="btn_sm_gallery" href="#" className={`menu-item ${activeItem === "btn_sm_gallery" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_sm_gallery")}>Galeria</Link>
          </div>
          <div className="h-[30px]">
            <Link to="contact" smooth={true} duration={500} offset={-150} id="btn_sm_contact" href="#" className={`menu-item ${activeItem === "btn_sm_contact" ? "menu-item-active" : ""}`} onClick={() => setActiveItem("btn_sm_contact")}>Kontakt</Link>
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;